import { useIsLight } from '@gef-ui/material-theme-utils/hooks';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { emphasize } from '@mui/system';
import { SnackbarProvider } from 'notistack';
import PropTypes from 'prop-types';
import React from 'react';
import { passSx, sxPropType } from '../utils';
const MuiAlertWrapper = /*#__PURE__*/ React.forwardRef(function MuiAlertWrapper({ id, variant, message, action: componentOrFunctionAction, title, AlertProps = {} }, ref) {
    const theme = useTheme();
    const isLight = useIsLight();
    const defaultBackgroundColor = emphasize(theme.palette.background.paper, isLight ? 0.8 : 0.98);
    const isDefault = variant === 'default';
    let action = componentOrFunctionAction;
    if (typeof action === 'function') {
        action = action(id);
    }
    return /*#__PURE__*/ React.createElement(Alert, {
        sx: isDefault ? {
            backgroundColor: defaultBackgroundColor,
            color: theme.palette.getContrastText(defaultBackgroundColor)
        } : undefined,
        variant: "filled",
        ref: ref,
        severity: isDefault ? undefined : variant,
        action: action,
        ...AlertProps
    }, title && /*#__PURE__*/ React.createElement(AlertTitle, null, title), message);
});
MuiAlertWrapper.propTypes = {
    AlertProps: PropTypes.object,
    action: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.func
    ]),
    id: PropTypes.number,
    message: PropTypes.node,
    title: PropTypes.node,
    variant: PropTypes.oneOf([
        'default',
        'success',
        'error',
        'warning',
        'info'
    ])
};
const styledComponents = {
    default: MuiAlertWrapper,
    success: MuiAlertWrapper,
    error: MuiAlertWrapper,
    warning: MuiAlertWrapper,
    info: MuiAlertWrapper
};
const NotistackProvider = ({ sx, useComputeSx = ()=>{}, ...props })=>{
    const theme = useTheme();
    const computedSx = useComputeSx();
    return /*#__PURE__*/ React.createElement(Box, {
        sx: [
            {
                '& .notistack-SnackbarContainer': {
                    zIndex: theme.zIndex.snackbar
                }
            },
            ...passSx(sx),
            ...passSx(computedSx)
        ]
    }, /*#__PURE__*/ React.createElement(SnackbarProvider, {
        ...props,
        Components: styledComponents
    }));
};
NotistackProvider.propTypes = {
    sx: sxPropType
};
export default NotistackProvider;
